import _extends from '@babel/runtime/helpers/extends';
import { __rest } from '../../../dependencies/tslib/tslib.es6.js';
import React__default, { useCallback } from 'react';
import './Button.scss.js';
import Preloader from '../Preloader/Preloader.js';
import { classnames } from '../../../utils/classnames.js';

var Button = function Button(_a) {
  var _a$type = _a.type,
      type = _a$type === void 0 ? 'button' : _a$type,
      _a$size = _a.size,
      size = _a$size === void 0 ? 'm' : _a$size,
      _a$fullWidth = _a.fullWidth,
      fullWidth = _a$fullWidth === void 0 ? false : _a$fullWidth,
      _a$buttonType = _a.buttonType,
      buttonType = _a$buttonType === void 0 ? 'primary' : _a$buttonType,
      preloader = _a.preloader,
      _a$textColor = _a.textColor,
      textColor = _a$textColor === void 0 ? 'default' : _a$textColor,
      _a$round = _a.round,
      round = _a$round === void 0 ? false : _a$round;
      _a.pressedCondition;
      var children = _a.children,
      startAdornment = _a.startAdornment,
      endAdornment = _a.endAdornment,
      props = __rest(_a, ["type", "size", "fullWidth", "buttonType", "preloader", "textColor", "round", "pressedCondition", "children", "startAdornment", "endAdornment"]);

  var getPreloaderSize = useCallback(function () {
    if (size === 'xs' || size === 's') {
      return 's';
    }

    return 'm';
  }, [size]);
  return /*#__PURE__*/React__default.createElement("button", _extends({}, props, {
    type: type,
    className: classnames(props.className, 'rf-button', "rf-button--".concat(buttonType), "rf-button--".concat(size), buttonType === 'text' && "rf-button--text-".concat(textColor), fullWidth && 'rf-button__full-width', round && 'rf-button--round'),
    "data-v-6e52f9c7": ""
  }), /*#__PURE__*/React__default.createElement("div", {
    "data-testid": "rf-button__content",
    className: classnames('rf-button__content', preloader && 'rf-button__content--hidden'),
    "data-v-6e52f9c7": ""
  }, !!startAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-button__adornment rf-button__adornment--start",
    "data-v-6e52f9c7": ""
  }, startAdornment), !!children && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-button__text",
    "data-v-6e52f9c7": ""
  }, children), !!endAdornment && /*#__PURE__*/React__default.createElement("div", {
    className: "rf-button__adornment rf-button__adornment--end",
    "data-v-6e52f9c7": ""
  }, endAdornment)), !!preloader && /*#__PURE__*/React__default.createElement(Preloader, {
    className: classnames(buttonType === 'round' && 'rf-button--round-loading'),
    size: getPreloaderSize(),
    variant: "inherit",
    "data-v-6e52f9c7": ""
  }));
};

export { Button as default };
